import React, { Component } from 'react';
import { connect } from 'react-redux';

import purchaseActions from '../../../actions/transactions/purchases';
import basketActions from '../../../actions/transactions/basket';

class PaymentConfirmation extends Component {

    componentDidMount() {
        const { reissuePermissions, clearBasket } = this.props;

        reissuePermissions();
        clearBasket();
    }

    render() {
        return <div>Thank you for your payment.</div>;
    };
}

const mapStateToProps = ( state ) => {
    return state;
};

const mapDispatchToProps = ( dispatch ) => {
    return {
        clearBasket: () => dispatch( basketActions.clearBasket() ),
        reissuePermissions: () => dispatch( purchaseActions.reissuePermissions() ),
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( PaymentConfirmation );



// WEBPACK FOOTER //
// src/client/components/site/pages/PaymentConfirmation.js